<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="clearData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in dataTable" :key="item.id">
            <td width="5" align="center">{{index+1}}</td>
            <td width="30%">{{item.message}}</td>
            <td>{{item.email}}</td>
            <td>{{item.phone}}</td>
            <td width="5%">{{item.is_reply}}</td>
            <td width="12%">{{item.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script>
    import CircleButton from "../../../components/Button/CircleButton";
    import InputSearch from "../../../components/Input/InputSearch";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import {mapState} from "vuex";
    export default {
        name: "SupportContactTable",
      components: {IconPencil, InputSearch, CircleButton},
      data(){
          return{
            title : 'Contact Support',
            headers: [
              { id: 1, text: "No." },
              { id: 2, text: "Message" },
              { id: 3, text: "Mail" },
              { id: 4, text: "Phone" },
              { id: 5, text: "Response" },
              { id: 6, text: "Update date" },
              { id: 7, text: "Edit" }
            ],
            dataTable :[],
          }
        },
      created() {
          this.getDataTable(1);
      },
      computed: {
        ...mapState({
          form: state => {
            return state.SupportContact.form;
          }
        })
      },
      methods:{
          getDataTable(page){
            this.$store.dispatch("SupportContact/getData",page).then(res=>{
              if(res.response_code === 200){
                this.dataTable = res.result.data;
              }
            }).catch(()=>{
              alert('cannot to request data');
            })
          },
        goToDataEdit(){
            this.$router.push("/customer-support/contact/edit");
        },
        showData(id){
            this.$store.dispatch("SupportContact/showData",id).then(res=>{
              if(res.response_code === 200){
                this.$store.dispatch("SupportContact/setFormData",res.result).then(()=>{
                  this.goToDataEdit();
                })
              }
            })
        },
        clearData(){
            this.$store.dispatch("SupportContact/clearFormData").then(()=>{
              this.goToDataEdit();
            });
        }
      },
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/variables.scss";
  .branch-data {
    background-color: $background-theme;
    margin: $margin-search;
  }
</style>
